var RwAjaxLove = (function () {

  // funzione php: inc/riservata/lovr/func-ajax-love.php
  // La security è definita in inc/enqueue.php da rw_ajax_obj
  var lovva = function (post_id, post_type, blog_id) {

    $.ajax({
      url : rw_ajax_obj.ajax_url,
      type : 'post',
      data : {
        action : 'rw_ajax_love',
        security : rw_ajax_obj.ajax_nonce,
        post_id : post_id,
        post_type : post_type,
        blog_id : blog_id
      },
      beforeSend: function() {
      },
      success : function( response ) {
        // response = $.parseJSON(response);
        // console.log(response)
      },
      error: function( jqXHR, textStatus, errorThrown ){
        console.log( 'Errore: ' + textStatus, errorThrown );
      },
      complete: function( jqXHR, textStatus ){
      }
    });

  };


  var start = function () {

    // console.log('ajax-love started');
    // reset stato pulsante love
    $('#start-love i').removeClass('fas').addClass('fal');

    $('.love-button i').click(function(e){
      e.preventDefault();
      var post_id = $(this).parent().data('id');
      var post_type = $(this).parent().data('type');
      var blog_id = $(this).parent().data('blog');
      console.log('post_id: ' + post_id + ' post_type: ' + post_type + ' blog_id: ' + blog_id);
      lovva(post_id, post_type, blog_id);

      // toggle dell'icona cuore piena/vuota
      var love_btn = '.love-' + post_type + '-' + post_id + ' i';
      if($(love_btn).hasClass('fal')){
        $(love_btn).removeClass('fal').addClass('fas');
      } else {
        $(love_btn).removeClass('fas').addClass('fal');
      }

      // aggiungo la classe loved sia a griglia che a lista in modo da poterla filtrare senza ricaricare
      $('.' + post_type + '-' + post_id).toggleClass('loved');
    });

  };


  return {
    start : start
  }


})();
